import React from "react";

const ArtTabs = ({ activeTab, setActiveTab, language, movies, books, games }) => {
  const tabs = [
    { key: "movie", label: language === "ru" ? "Фильмы" : "Movies", data: movies },
    { key: "book", label: language === "ru" ? "Книги" : "Books", data: books },
    { key: "videoGame", label: language === "ru" ? "Игры" : "Games", data: games },
  ];

  return (
    <div className="flex justify-center items-center gap-3">
      {tabs.map((tab) => {
        const isActive = activeTab === tab.key;
        const isLoading = tab.data === null;
        const count = tab.data?.length;
        return (
          <div
            key={tab.key}
            onClick={() => setActiveTab(tab.key)}
            className={`px-5 py-2 rounded-xl text-sm font-medium transition-all cursor-pointer border backdrop-blur-sm
              ${isActive
                ? "bg-gray-700 border-gray-500 text-white shadow-md"
                : "bg-gray-800 border-gray-600 text-gray-300 hover:bg-gray-700 hover:text-white"}
            `}
          >
            {tab.label}
            {isLoading ? (
              <span className="ml-2 inline-flex items-center">
                <span className="inline-block h-3 w-3 animate-spin rounded-full border-2 border-gray-400 border-t-transparent" />
              </span>
            ) : (
              count !== undefined && ` (${count})`
            )}
          </div>
        );
      })}
    </div>
  );
};

export default ArtTabs;
